export enum Products {
  Mastermind = "Mastermind",
  SoftwareAccess1Year = "SoftwareAccess1Year",
}
